import PageName from "../../components/PageName";
import React, {useEffect, useState} from "react";
import Card from "../../components/Base/Card";
import {FiBell, FiLock, FiUser} from "react-icons/fi";
import ManageAccount from "../../components/settings/ManageAccount";
import {SettingTab} from "../../constants";
import ChangePassword from "../../components/settings/ChangePassword";
import Subscriptions from "../../components/settings/Subscriptions";
import PasscodeManagement from "../../components/settings/PasscodeManagement";
import KYC from "../../components/settings/KYC";
import RecaptureModal from "../../components/Auth/RecaptureModal";
import RecaptureComponent from "../../components/settings/RecaptureComponent";
import InactivityTimeoutHOC from "../auth/inactivity-timeout-hoc";

const AccountSettings = () => {
    const [currentTab, setCurrentTab] = useState(SettingTab.ACCOUNT_MANAGER);

    const [showRecaptureModal, setShowRecaptureModal] = useState(false)

    const accountTabs = [
        {
            id: SettingTab.ACCOUNT_MANAGER,
            icon: <FiUser/>,
            text: "Account Manager",
            head: "Manage your account"
        },
        {
            id: SettingTab.KYC,
            icon: <FiUser/>,
            text: "Update KYC Information",
            head: "KYC",
        },
        {
            id: SettingTab.PASSCODE_MANAGEMENT,
            icon: <FiLock />,
            head: "Passcode Management",
            text: "Manage your passcode"
        },
        {
            id: SettingTab.CHANGE_PASSWORD,
            icon: <FiLock />,
            head: "Change Password",
            text: "Manage your password"
        },
        {
            id: SettingTab.SUBSCRIPTIONS,
            icon: <FiBell />,
            head: "Subscriptions",
            text: "Your account subscriptions"
        },
        {
            id: SettingTab.RECPATURE,
            icon: <FiUser />,
            head: "Recapure",
            text: "It will redirect you to the link"
        },
    ]
    // dispatch(generateRecaptureLink(dispatchLogin.payload.pin));
    // setShowRecaptureModal(true);
    
    useEffect(() => {
        // Check local storage for 'enforceChangePassword' value
        const enforceChangePassword = localStorage.getItem('enforceChangePassword');
        if (enforceChangePassword === 'true') {
          // If 'enforceChangePassword' is 'true', set the currentTab to CHANGE_PASSWORD
          setCurrentTab(SettingTab.CHANGE_PASSWORD);
        }
      }, []); // Empty dependency array means this effect runs once after the component mounts
    


    return (
        <div className="transaction-page settings-page">
            <PageName pageName={"Feedback"} />
            <div className="transaction">
                <Card className="transaction-card">
                    <div className="h1 text-grayscaleBody border-b pb-4">
                        Account Settings
                    </div>
                    <div className="section-card-large">
                        <div>
                            <div className="settings-tab">
                                { accountTabs.map((tab)=>(
                                    <div
                                        className={`tab ${ tab.id === currentTab ? 'selected': ''}`}
                                        onClick={()=>setCurrentTab(tab.id)}
                                        key={tab.id}
                                    >
                                        <div className="tab__icon">
                                            {tab.icon}
                                        </div>
                                        <div className="tab__text">
                                            <div className="tab__text--head">{tab.head}</div>
                                            <div className="tab__text--text">{tab.text}</div>
                                        </div>
                                    </div>))
                                }
                            </div>
                        </div>
                        {
                            currentTab === SettingTab.ACCOUNT_MANAGER ?
                                <ManageAccount />
                                : <></>
                        }
                        {
                            currentTab === SettingTab.KYC ?
                                <KYC onSuccess={()=>{}} />
                                : <></>
                        }

                        {
                            currentTab === SettingTab.PASSCODE_MANAGEMENT ?
                                <PasscodeManagement />
                                : <></>
                        }
                        {
                            currentTab === SettingTab.CHANGE_PASSWORD ?
                                <ChangePassword />
                                : <></>
                        }
                        {
                            currentTab === SettingTab.SUBSCRIPTIONS ?
                                <Subscriptions />
                                : <></>
                        }

{
                            currentTab === SettingTab.RECPATURE ?

                            <RecaptureComponent/>
                        //     <RecaptureModal
                        //     showModal={showRecaptureModal}
                        //     onClose={() => setShowRecaptureModal(false)}
                        //     onSuccess={restartLogin}
                        //   />
                                
                                : <></>
                        }
                    </div>
                </Card>
                {/* <RecaptureModal
          showModal={showRecaptureModal}
          onClose={()=>setShowRecaptureModal(false)}
          onSuccess={restartLogin}
      /> */}
            </div>
        </div>
    )
}
export default InactivityTimeoutHOC(AccountSettings, 900000);